import { stateGo } from 'redux-ui-router';
import { memberStorage } from 'utils';
import { selectMealPlanId } from 'logic/product';
import {
  selectMemberIsVegetarian,
  selectHasWeeklySubscription,
} from 'logic/member';

// This handles redirecting to the the mealPlan and ShoppingList which requires
// a mealPlanId. It will use the default mealPlanId for the program week.
export const ProgramRedirect = {
  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const { member, product, router } = $ngRedux.getState();
        const { weekNumber } = router.currentParams;
        const path = router.currentState.name.replace('Redirect', '');

        const isBasicMealPlan = selectHasWeeklySubscription(member);
        const isVegetarian = selectMemberIsVegetarian(member);
        const clonedMealPlanIds = isBasicMealPlan
          ? undefined
          : memberStorage.get().mealPlanIds;

        const mealPlanId = selectMealPlanId(
          product,
          weekNumber,
          isVegetarian,
          clonedMealPlanIds
        );

        $ngRedux.dispatch(stateGo(path, { mealPlanId }));
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Program/Redirect.js